[
  {
    "code": "PW-002",
    "name": "Aimeliik"
  },
  {
    "code": "PW-004",
    "name": "Airai"
  },
  {
    "code": "PW-010",
    "name": "Angaur"
  },
  {
    "code": "PW-050",
    "name": "Hatobohei"
  },
  {
    "code": "PW-100",
    "name": "Kayangel"
  },
  {
    "code": "PW-150",
    "name": "Koror"
  },
  {
    "code": "PW-212",
    "name": "Melekeok"
  },
  {
    "code": "PW-214",
    "name": "Ngaraard"
  },
  {
    "code": "PW-218",
    "name": "Ngarchelong"
  },
  {
    "code": "PW-222",
    "name": "Ngardmau"
  },
  {
    "code": "PW-224",
    "name": "Ngatpang"
  },
  {
    "code": "PW-226",
    "name": "Ngchesar"
  },
  {
    "code": "PW-227",
    "name": "Ngeremlengui"
  },
  {
    "code": "PW-228",
    "name": "Ngiwal"
  },
  {
    "code": "PW-350",
    "name": "Peleliu"
  },
  {
    "code": "PW-370",
    "name": "Sonsorol"
  }
]